module.exports = __webpack_public_path__ + "static/media/LBox_logo.d62d2d4b.png";